import styled from '@emotion/styled'

const getResponsiveValue = (value, defaultValue) => {
  if (!value) {
    return defaultValue
  }
  if (typeof value === 'object') {
    return value.base || defaultValue
  }
  return value
}

export const Box = styled.div`
  display: ${({ display = 'flex' }) => display};
  visibility: ${({ visibility }) => visibility};
  flex-direction: ${({ direction }) => getResponsiveValue(direction, 'row')};
  width: ${({ width }) => getResponsiveValue(width, 'auto')};
  align-items: ${({ align }) => getResponsiveValue(align, 'normal')};
  justify-content: ${({ justify }) => getResponsiveValue(justify, 'normal')};

  @media (min-width: 640px) {
    flex-direction: ${({ direction }) =>
    typeof direction === 'object' && direction.sm};
    width: ${({ width }) => typeof width === 'object' && width.sm};
    align-items: ${({ align }) => typeof align === 'object' && align.sm};
    justify-content: ${({ justify }) =>
    typeof justify === 'object' && justify.sm};
  }

  @media (min-width: 768px) {
    flex-direction: ${({ direction }) =>
    typeof direction === 'object' && direction.md};
    align-items: ${({ align }) => typeof align === 'object' && align.md};
    width: ${({ width }) => typeof width === 'object' && width.md};
    justify-content: ${({ justify }) =>
    typeof justify === 'object' && justify.md};
  }

  @media (min-width: 1024px) {
    flex-direction: ${({ direction }) =>
    typeof direction === 'object' && direction.lg};
    align-items: ${({ align }) => typeof align === 'object' && align.lg};
    width: ${({ width }) => typeof width === 'object' && width.lg};
    justify-content: ${({ justify }) =>
    typeof justify === 'object' && justify.lg};
  }

  @media (min-width: 1280px) {
    flex-direction: ${({ direction }) =>
    typeof direction === 'object' && direction.xl};
    align-items: ${({ align }) => typeof align === 'object' && align.xl};
    width: ${({ width }) => typeof width === 'object' && width.xl};
    justify-content: ${({ justify }) =>
    typeof justify === 'object' && justify.xl};
  }

  max-width: ${({ maxWidth }) => getResponsiveValue(maxWidth, 'none')};
  min-width: ${({ $minWidth }) => getResponsiveValue($minWidth, '0px')};
  height: ${({ height }) => getResponsiveValue(height, 'auto')};
  min-height: ${({ $minHeight }) => getResponsiveValue($minHeight, '0px')};
  max-height: ${({ maxHeight }) => maxHeight};
  margin: ${({ margin = 0 }) => margin};
  padding: ${({ padding = 0 }) => padding};
  gap: ${({ gap = 0 }) => gap};
  background: ${({ background = 'none' }) => background};
  border: ${({ border = 'none' }) => border};
  border-radius: ${({ borderRadius = 'none' }) => borderRadius};
  border-width: ${({ borderWidth }) => borderWidth};
  flex-wrap: ${({ wrap = 'nowrap' }) => wrap};
  flex-grow: ${({ flexGrow = 0 }) => flexGrow};
  flex-shrink: ${({ flexShrink = 1 }) => flexShrink};
  overflow: ${({ overflow = 'visible' }) => overflow};
  cursor: ${({ cursor = 'inherit' }) => cursor};
  position: ${({ position = 'static' }) => position};
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  bottom: ${({ bottom }) => bottom};
  left: ${({ left }) => left};
  text-align: ${({ textAlign = 'start' }) => textAlign};
  opacity: ${({ opacity = 1 }) => opacity};
  grid-column: ${({ gridColumn = 'auto' }) => gridColumn};
  grid-row: ${({ gridRow = 'auto' }) => gridRow};
  grid-template-columns: ${({ gridColumns }) => gridColumns};
  white-space: ${({ $whiteSpace }) => $whiteSpace};
  pointer-events: ${({ pointerEvents }) => pointerEvents};
  transform: ${({ rotate }) => rotate && `rotate(${rotate}deg)`};
  user-select: ${({ $userSelect }) => $userSelect};
  box-shadow: ${({ boxShadow }) => boxShadow};
  word-break: ${({ wordBreak }) => wordBreak};
`